import { useState, useEffect } from "react";

interface UseFontSelectStateProps {
  value?: string;
  searchTerm: string;
}

export const useFontSelectState = ({
  value,
  searchTerm,
}: UseFontSelectStateProps) => {
  const [expandedFamilies, setExpandedFamilies] = useState<Set<string>>(
    new Set()
  );
  const [selectedFont, setSelectedFont] = useState<string | undefined>(value);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    setSelectedFont(value);
  }, [value]);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setExpandedFamilies(new Set());
    }
  }, [searchTerm]);

  const toggleFamilyExpansion = (familyName: string, isExpanded: boolean) => {
    const newExpandedFamilies = new Set(expandedFamilies);
    if (isExpanded) {
      newExpandedFamilies.add(familyName);
    } else {
      newExpandedFamilies.delete(familyName);
    }
    setExpandedFamilies(newExpandedFamilies);
  };

  return {
    expandedFamilies,
    selectedFont,
    dropdownVisible,
    setSelectedFont,
    setDropdownVisible,
    setExpandedFamilies,
    toggleFamilyExpansion,
  };
};
